import React from "react";
import { Box, Chip, MenuItem, Stack } from '@mui/material';
import * as _ from "lodash";
import { darkenHexColor, lightenHexColor, useTagsQuery } from '../shared';
import { SelectInput } from '@coverright/ui/inputs';
import { Check, Circle } from '@phosphor-icons/react';
import { TagOutput } from '@coverright/data-access/types/enrollment';

interface TagSelectorProps {
  onChange: (values: TagOutput[]) => void;
  selectedValues: string[];
  label?: string;
  className?: string;
}
export const TagSelector = (props: TagSelectorProps) => {
  const {data} = useTagsQuery();

  const tags = _.orderBy(data?.tags || [], 'name');

  const getTagById = (id: string) => tags.find(t => t.id === id);

  return <SelectInput label={props.label}
                     value={props.selectedValues}
                     onChange={event => {
                       props.onChange(tags.filter(t => (event.target.value as string[]).includes(t.id)))
                     }}
                      hideTick
                      className={props.className}
                     sx={{minWidth: 200}}
                     multiple
                     renderValue={(selected) => {
                       if ((selected as string[]).length === 0) {
                         return <>{props.label ? '-' : 'Tags'}</>;
                       }
                       return <Stack direction={'row'} flexWrap={'wrap'} gap={1}>
                         {(selected as string[]).map((value) => (
                           <TagChip key={value} tag={getTagById(value)} />
                         ))}
                       </Stack>
                     }}
  >
    {tags.map(tag => <MenuItem key={tag.id} value={tag.id}>
      <Box display={'flex'} gap={2} width={1}>
        <Circle size={15} weight={'fill'} color={tag.color || '#000'} />
        {tag.name}
        {props.selectedValues.includes(tag.id) && <Check size={24} color={'#056048'} style={{marginLeft: 'auto'}} />}
      </Box>
    </MenuItem>)}
  </SelectInput>
}


const TagChip = ({tag}: {tag?: TagOutput}) => (
  !tag ? null : (
    <Chip sx={{
      backgroundColor: lightenHexColor(tag.color || '#111827', 70),
      border: `1px solid ${tag.color}`,
      color: darkenHexColor(tag.color || '#111827', 60)
    }}
          size="small"
          label={_.upperFirst(tag.name.toLowerCase()) || ''}  />
  )
)
